import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { exhaustMap, first, shareReplay } from 'rxjs/operators';

import { TipoPessoaEnum } from 'src/app/shared/enums/tipo-pessoa.enum';
import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { CrudOperations } from 'src/app/shared/interfaces/crud-operations.interface';
import { ClienteRequest, EnderecoPessoa, PessoaModel } from 'src/app/shared/models/pessoa.model';
import { AuthenticationService } from './authentication.service';

@Injectable({
    providedIn: 'root'
})
export class PessoaService implements CrudOperations<PessoaModel> {
    private fetch$ = new BehaviorSubject<void>(undefined);

    clientes$: Observable<ApiResponse<PessoaModel[]>> = this.fetch$.pipe(
        exhaustMap(() => this.getPessoasByTipo(TipoPessoaEnum.Cliente)),
        shareReplay(),
    );

    constructor(
        private httpClient: HttpClient,
        private authService: AuthenticationService
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/Pessoas`;
    }

    create(model: PessoaModel): Observable<ApiResponse<PessoaModel>> {
        return this.httpClient.post<ApiResponse<PessoaModel>>(this.base + '/create', model).pipe(
            first()
        );
    }

    AddOrUpdate(model: PessoaModel): Observable<ApiResponse<PessoaModel>> {
        if (model.codigo == 0)
            return this.create(model);
        else
            return this.update(model.codigo, model);
    }


    delete(id: number): Observable<ApiResponse<any>> {
        return this.httpClient.delete<ApiResponse<any>>(this.base + '/' + id).pipe(
            first()
        );
    }

    get(): Observable<ApiResponse<PessoaModel[]>> {
        return this.httpClient.get<ApiResponse<PessoaModel[]>>(this.base).pipe(
            first()
        );
    }

    getByCpf(cpf: string) {
        return this.httpClient.get<ApiResponse<PessoaModel>>(`${this.base}/cpf/${cpf}`).pipe(
            first()
        );
    }

    getById(id: number): Observable<ApiResponse<PessoaModel>> {
        return this.httpClient.get<ApiResponse<PessoaModel>>(this.base + '/' + id).pipe(
            first()
        );
    }

    getEmpresasIntegracao(): Observable<ApiResponse<PessoaModel[]>> {
        return this.httpClient.get<ApiResponse<PessoaModel[]>>(this.base + '/empresasIntegracao').pipe(
            first()
        );
    }

    getPessoasByTipo(tipoPessoa: TipoPessoaEnum) {
        return this.httpClient.get<ApiResponse<Array<PessoaModel>>>(`${this.base}/tipoPessoa/${tipoPessoa}`).pipe(
            first()
        );
    }

    refreshClientes() {
        this.fetch$.next();
    }

    update(id: number, model: PessoaModel): Observable<ApiResponse<PessoaModel>> {
        return this.httpClient.put<ApiResponse<PessoaModel>>(this.base + '/' + id, model, {}).pipe(
            first()
        );
    }

    getAll(texto: string) {
        return this.httpClient.get<ApiResponse<PessoaModel[]>>(`${this.base}/getAll/${texto}`).pipe(
            first()
        );
    }

    getAllEnderecos(codPessoa: number) {
        return this.httpClient.get<ApiResponse<EnderecoPessoa[]>>(`${this.authService.baseUrl}/enderecos/pessoa/${codPessoa}`).pipe(
            first()
        );
    }

    AddOrUpdateEndereco(enderecoPessoa: EnderecoPessoa) {
        if (enderecoPessoa.codigo == 0) {
            return this.httpClient.post<ApiResponse<EnderecoPessoa>>(`${this.authService.baseUrl}/enderecos/create`, enderecoPessoa).pipe(
                first()
            );
        }
        else {
            return this.httpClient.put<ApiResponse<EnderecoPessoa>>(`${this.authService.baseUrl}/enderecos/${enderecoPessoa.codigo}`, enderecoPessoa).pipe(
                first()
            );
        }
    }

}
